import * as z$1 from "zod/v4";
//#region src/computer-connection-progress.ts
const computerConnectionProgressPhaseSchema = z$1.enum([
	"checking",
	"downloading",
	"verifying",
	"installing",
	"waiting_for_confirmation",
	"switching_account",
	"finishing_previous_connection",
	"waiting_for_current_work",
	"connecting_service",
	"confirming",
	"connected",
	"restoring",
	"needs_attention"
]);
const computerConnectionProgressMeasurementSchema = z$1.strictObject({
	unit: z$1.literal("bytes"),
	value: z$1.number().int().nonnegative(),
	total: z$1.number().int().positive(),
	transferAttempt: z$1.number().int().positive()
});
const computerConnectionProgressObservationSchema = z$1.strictObject({
	schemaVersion: z$1.literal(1),
	operationId: z$1.string().min(1).max(128),
	attemptId: z$1.string().min(1).max(128),
	prepareSessionId: z$1.string().min(1).max(256).nullable(),
	sequence: z$1.number().int().nonnegative(),
	startedAt: z$1.string().datetime(),
	observedAt: z$1.string().datetime(),
	phase: computerConnectionProgressPhaseSchema,
	state: z$1.enum([
		"active",
		"completed",
		"failed"
	]),
	code: z$1.string().min(1).max(256),
	measurement: computerConnectionProgressMeasurementSchema.optional(),
	detail: z$1.string().min(1).max(512).optional()
});
//#endregion
export { computerConnectionProgressMeasurementSchema, computerConnectionProgressObservationSchema, computerConnectionProgressPhaseSchema };

//# sourceMappingURL=computer-connection-progress.js.map